import { createSelector } from 'reselect'
import modelsWithSelectedSelector from './modelsWithSelectedSelector'
import filtersSelector from '../filtersSelector'
import Model from '../../../entities/Model'
import filterListSelector from '../filterListSelector'
import modelsPageFiltersEnabledSelector from '../modelsPageFiltersEnabledSelector'

const filteredModelsSelector = createSelector(
    modelsWithSelectedSelector,
    filtersSelector,
    filterListSelector,
    modelsPageFiltersEnabledSelector,
    (models, appliedFilters, filterList, modelsPageFiltersEnabled): Model[] => {
        if (!modelsPageFiltersEnabled) {
            return models
        }
        const activeFilters = Object.entries(appliedFilters)
        
        if (activeFilters.every(([, values]) => values.length === 0)) {
            return models
        }

        return models.filter((model) => {
            return activeFilters.every(([filterKey, filterValues]) => {
                if (filterValues.length === 0) {
                    return true
                }
                
                const filterConfig = filterList.find(filter => filter.attribute === filterKey)
                
                if (!filterConfig) {
                    return true
                }
                
                const modelAttribute = model.attributes.find(attr => attr.id === filterKey)
                if (!modelAttribute) {
                    return false
                }
                
                if (filterConfig.type === 'max') {
                    const numericModelValue = parseFloat(modelAttribute.value.toString())
                    const selectedMaxValue = filterValues[0]
                    const numericMaxValue = typeof selectedMaxValue === 'string' ? parseFloat(selectedMaxValue) : selectedMaxValue
                    
                    return !isNaN(numericModelValue) && 
                           !isNaN(numericMaxValue) &&
                           numericModelValue <= numericMaxValue
                }
                
                return filterValues.includes(modelAttribute.value)
            })
        })
    },
)

export default filteredModelsSelector
